import { render, staticRenderFns } from "./ImportStudentForm.vue?vue&type=template&id=68df17c8&scoped=true&"
import script from "./ImportStudentForm.vue?vue&type=script&lang=js&"
export * from "./ImportStudentForm.vue?vue&type=script&lang=js&"
import style0 from "./ImportStudentForm.vue?vue&type=style&index=0&id=68df17c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68df17c8",
  null
  
)

export default component.exports